// import { prefixPath } from '@/config'

export default function (index) {
  const config = this.dynamicList[index]
  if (!config) return []
  const list = config.formPropertyList.map(item => {
    if (item.propertyConfig && item.propertyConfig.indexOf('session_listOrgId') > -1) {
      item.propertyConfig = item.propertyConfig.replace('session_listOrgId', this.orgId)
    }
    if (item.propertyConfig && item.propertyConfig.indexOf('prefixPath') > -1) {
      item.propertyConfig = item.propertyConfig.replace('prefixPath', 'api-uum/')
    }
    const props = JSON.parse(item.propertyConfig || '{}')
    if (item.widgetType === 'fileUpload') {
      props.data = props.data || {}
      props.data.groupId = this.groupId || this.getUuid()
      props.isShowFileList = true
    }
    if (item.widgetType === 'InputNumber') {
      props.min = 0
    }
    if (item.widgetType === 'universalTree' && props.treeParams && props.treeParams.orgId === '') {
      props.treeParams.orgId = -1
    }
    //码表接口前缀
    if (props.url && props.url.indexOf('api-general') < 0 && props.params && props.params.dictCode) {
      props.url = 'api-general/module/portal/user/outGetList'
      props.params.bizLineCode = this.bizLineCode
    }
    if (item.description) {
      props.extra = true
    }
    if (config.groupType == 1) { //表单
      if (item.propertyCode == 'projLeaderName') {
        props.treeType = props.portalTreeType
        props.listUrl = props.portalListUrl
        props.sendListData = (id, name) => {
          return {
            orgId: id,
            userName: name,
            drillType: 1
          }
        }
      }
      return item.isEnabled == 1 ? {
        type: item.widgetType || 'Input',
        title: item.displayName || item.propertyName,
        [$field]: item.propertyCode,
        colSpan: item.colspan || 8,
        description: item.description || '',
        readOnly: item.isReadonly == 1 ? true : false,
        props: props,
        rules: item.isNotNull == 1 ? ['required'] : []
      } : null
    } else { //表格
      return item.isEnabled == 1 ? {
        showType: item.widgetType || '',
        title: item.displayName || item.propertyName,
        [$field]: item.propertyCode,
        width: item.width || 8,
        minWidth: item.minWidth || 10,
        readOnly: item.isReadonly == 1 ? true : false,
        props: props
      } : null
    }
  }).filter(v => v)
  return config.isEnabled == 1 ? list : []
}